<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "self-service",
};
</script>
